import type { DepartmentTypeResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDepartmentsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDepartmentsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, REFERENCE_DATA_STALE_TIME_MS } from 'src/utils';

type UseGetDepartmentsArgs = Record<string, never>;

export const useGetDepartments = createQueryHook<
  UseGetDepartmentsArgs,
  DepartmentTypeResponseRow[],
  GetDepartmentsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.department.allTypes.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ department_type: data }),
  // Org reference data; writes invalidate it. See COI-882.
  trpcStaleTime: REFERENCE_DATA_STALE_TIME_MS,
  graphqlDocument: GetDepartmentsDocument,
});
